// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__4vzqH","link":"Footer_link__wByfM","date":"Footer_date__oiTxl"};